import {Component, Input, Output, OnChanges, ViewChild, SimpleChanges, EventEmitter} from '@angular/core';
import {PowerBiService} from '../../core/services/power-bi.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})

export class IframeComponent implements OnChanges {
  @Input() params;
  @Input() style: {};
  @Input() activeTab;
  @Input() fullScreenMode = false;
  @Output() linkLoaded = new EventEmitter();
  @ViewChild('iframe') iframe;
  url;
  src;
  linkNotFound = false;
  oldBaseUrl;
  oldTipo = '';

  constructor(private _powerBi: PowerBiService, private _sanitizer: DomSanitizer) {
  }

  getPowerBi(getParams) {
    this._powerBi.getPowerBi(getParams)
      .subscribe(data => {
          if (data && data['link']) {
            this.url = data['link'];
            this.src = this._sanitizer.bypassSecurityTrustResourceUrl(this.url);
            this.linkNotFound = false;
          } else {
            this.linkNotFound = true;
            this.linkLoaded.emit();
          }
        },
        (error) => console.log(error)
      );
  }

  changeIframeTab(tab) {
    if (this.iframe) {
      if (tab['code']) {
        let baseUrl;
        if (this.oldBaseUrl) {
          baseUrl = this.oldBaseUrl.split('#');
        } else {
          baseUrl = this.iframe.nativeElement.src.split('#');
        }
        this.iframe.nativeElement.src = baseUrl[0] + '#gid=' + tab['code'];
      } else {
        this.oldBaseUrl = this.iframe.nativeElement.src;
        this.iframe.nativeElement.src = tab['src'];
      }
    }
  }

  openFullScreen(iframe) {
    if (iframe.requestFullscreen) {
      iframe.requestFullscreen();
    } else if (iframe.mozRequestFullScreen) {
      iframe.mozRequestFullScreen();
    } else if (iframe.webkitRequestFullscreen) {
      iframe.webkitRequestFullscreen();
    } else if (iframe.msRequestFullscreen) {
      iframe.msRequestFullscreen();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.params && changes.params.currentValue && changes.params.currentValue['tipo'] !== this.oldTipo) {
      this.oldTipo = changes.params.currentValue['tipo'];
      this.getPowerBi(this.params);
    } else if ((!changes.style || !changes.style.currentValue) && (!changes.activeTab || !changes.activeTab.currentValue)) {
      this.src = this._sanitizer.bypassSecurityTrustResourceUrl('https://loja.rectrix.com.br/login');
    }
    if (changes.activeTab && changes.activeTab.currentValue) {
      this.changeIframeTab(this.activeTab);
    }
  }
}
